var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlueLock = function SvgBlueLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 61.5,
    viewBox: "0 0 52 61.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Pin_Code_97219",
    "data-name": "noun_Pin Code_97219",
    transform: "translate(-24 -19.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17360",
    "data-name": "Group 17360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17353",
    "data-name": "Group 17353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10648",
    "data-name": "Path 10648",
    d: "M71,81H29a4.951,4.951,0,0,1-5-5V50a4.951,4.951,0,0,1,5-5H71a4.951,4.951,0,0,1,5,5V76A4.951,4.951,0,0,1,71,81ZM29,47a2.946,2.946,0,0,0-3,3V76a2.946,2.946,0,0,0,3,3H71a2.946,2.946,0,0,0,3-3V50a2.946,2.946,0,0,0-3-3Z",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17354",
    "data-name": "Group 17354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10649",
    "data-name": "Path 10649",
    d: "M66,45.5H64V35.7A14.255,14.255,0,0,0,49.8,21.5,13.828,13.828,0,0,0,36,35.3V45.5H34V35.3A15.834,15.834,0,0,1,49.8,19.5,16.261,16.261,0,0,1,66,35.7Z",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17359",
    "data-name": "Group 17359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17355",
    "data-name": "Group 17355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10650",
    "data-name": "Path 10650",
    d: "M32.4,66l-3-2.4.7-.8c.1-.2.3-.3.4-.5-.3-.1-.5-.1-.6-.2l-.9-.2,1.2-3.5,1,.4c.2.1.3.1.5.2V57.4h3.6v1.7a4.875,4.875,0,0,1,.7-.3l1-.4,1.1,3.7-1,.2c-.2,0-.4.1-.6.1.2.2.3.4.4.5l.7.9-3.1,2.1-.9-1.4c-.1.2-.3.4-.4.6Z",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17356",
    "data-name": "Group 17356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10651",
    "data-name": "Path 10651",
    d: "M43,66l-3-2.4.7-.8c.1-.2.3-.3.4-.5-.3-.1-.5-.1-.6-.2l-.9-.3,1.2-3.5,1,.4c.2.1.3.1.5.2V57.3h3.6V59a4.875,4.875,0,0,1,.7-.3l1-.4L48.7,62l-1,.2c-.2,0-.4.1-.6.1.2.2.3.4.4.5l.7.9-3.1,2.1L44,64.5c-.1.2-.3.4-.4.6Z",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17357",
    "data-name": "Group 17357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10652",
    "data-name": "Path 10652",
    d: "M53.6,66l-3-2.4.7-.8c.1-.2.3-.3.4-.5-.3-.1-.5-.1-.6-.2l-.9-.3,1.2-3.5,1,.4c.2.1.3.1.5.2V57.3h3.6V59a4.875,4.875,0,0,1,.7-.3l1-.4L59.3,62l-1,.2c-.2,0-.4.1-.6.1.2.2.3.4.4.5l.7.9-3.1,2.1-.9-1.4c-.1.2-.3.4-.4.6Z",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17358",
    "data-name": "Group 17358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10653",
    "data-name": "Path 10653",
    d: "M64.2,66l-3-2.4.7-.8c.1-.2.3-.3.4-.5-.3-.1-.5-.1-.6-.2l-.9-.3L62,58.3l1,.4c.2.1.3.1.5.2V57.3H67V59a4.875,4.875,0,0,1,.7-.3l1-.4L69.8,62l-1,.2c-.2,0-.4.1-.6.1.2.2.3.4.4.5l.7.9-3.1,2.1-.9-1.4c-.1.2-.3.4-.4.6Z",
    fill: "#07a3c8"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlueLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blueLock.ba873ef8.svg";
export { ForwardRef as ReactComponent };